import type { FaireThemeEntity } from "../../entity_types/theme";

export const grab_and_go_refreshments: FaireThemeEntity = {
  token: "grab-and-go-refreshments",
  type: "theme",
  name: "Grab-and-Go Refreshments",
  description: "Keep your patrons refreshed with a variety of juices, teas, and premium waters. These beverages are perfect for impulse buys at your brick-and-mortar checkout.",
  teaser: "As a gift shop in Washington, DC, that already sells snacks like chips and chocolate bars, adding a beverage selection is a natural extension of your 'Brick & Mortar' inventory.",
  detail: "The additional_context payload supports this theme because your most recent carts are heavily focused on beverage staples like Everfresh Apple Juice, Arizona Iced Teas, and Core Water.",
  bgColor: "#D5E8D4",
  tileBgColor: "#6b6337",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_av8bwntabe",
    "p_jsqerahfqc",
    "p_hnfmpw2q3y",
    "p_f3yxgc29pu",
    "p_hjzbbyjpzr",
    "p_vsp93am2rx",
    "p_quhrj44ew5",
    "p_yr9bn6eek9",
    "p_vpvpnz9qgx",
    "p_6dzjqu3hvk",
    "p_f9jtxegv6y",
    "p_5dx9thfmvf",
    "p_zryeheg22y",
    "p_535bv2wvzp",
    "p_s69zu73tc4",
    "p_kfwr9rsz7b",
    "p_rffayupe4t",
    "p_2xjdcstmhf",
    "p_sydx2kr3c6",
    "p_anrekryv43",
    "p_qd2d3ntp4w",
    "p_3d2wq4u97s",
    "p_2t8khm78ub",
    "p_m4rzkc9nzm",
    "p_v42bpekr6b",
    "p_b67hq84shq",
    "p_s9evtgex34",
    "p_g3syszptaw",
    "p_7ehm9uwt6f",
    "p_w3uj4uemxp",
    "p_nxgeqkuueg",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
